import { render, staticRenderFns } from "./ErrorModalContainer.vue?vue&type=template&id=a205622a&"
import script from "./ErrorModalContainer.vue?vue&type=script&lang=ts&"
export * from "./ErrorModalContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports